<template>
  <div class="successfulpayment">
    <div class="successfulpayment-main">
      <div class="successfulpayment-main-container">
        <div class="successfulpayment-main-container-left">
          <img src="@/assets/imgs/successfulpayment.png" alt="" />
        </div>
        <div class="successfulpayment-main-container-right">
          <h1>支付成功</h1>
          <p>
            您已成功支付<span>¥798.00元</span>订单编号：11114012410250810824
          </p>
          <span class="span"
            >我们会尽快给您审核订单信息，提交到商标局！材料信息如有问题我们客服会及时与您联系。</span
          >
          <div>
            <el-button>在下一单</el-button><el-button class="seeDetail">查看订单详情</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.successfulpayment {
  width: 100%;
  padding: 20px 0;
  background: #f5f5f7;
  .successfulpayment-main {
    margin: 0 auto;
    max-width: 1240px;
    padding: 0 20px;
    .successfulpayment-main-container {
      width: 100%;
      background: #fff;
      padding: 122px 0 165px 195px;
      display: flex;
    }
  }
}
.successfulpayment-main-container-left {
  width: 142px;
  height: 142px;
  margin-right: 37px;
  img {
    width: 100%;
    height: 100%;
  }
}
.successfulpayment-main-container-right {
  h1 {
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(48, 113, 254, 1);
    line-height: 45px;
    margin-bottom: 24px;
  }
  p {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 20px;
    margin-bottom: 5px;
    span {
      font-size: 18px;
      color: #ff5b00;
      margin-right: 30px;
    }
  }
  .span {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 22px;
    margin-bottom: 66px;
    display: inline-block;
  }
  .el-button{
      width: 134px;
      height: 36px;
      padding: 0;
      border-radius: 0;
      border: 1px solid #3071FE;
      color: #3071FE;
      background: #fff;
  }
  .seeDetail{
      color: #fff;
      background: #3071FE;
  }
}
</style>
